import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ProjectComponent } from './project/project.component';
import { ImportPlanComponent } from './project/import-plan/import-plan.component';
import { CalculationProfitabilityComponent } from './calculation-profitability/calculation-profitability.component';
import { ItemListComponent } from './item-list/item-list.component';
import { PrintSystemDocumentsComponent } from './print-system-documents/print-system-documents.component';
import { PrintOfferComponent } from './print-offer/print-offer.component';
import { InstallationTimeComponent } from './installation-time/installation-time.component';
import { ManageProjectsComponent } from './manage-projects.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { PaginatorGotoComponent } from "../../common/components/paginator-goto/paginator-goto.component";
import { GeneralComponent } from './print-offer/general/general.component';
import { ExtraServicesComponent } from './print-offer/extra-services/extra-services.component';
import { OfferTextComponent } from './print-offer/offer-text/offer-text.component';
import { FinalTextComponent } from './print-offer/final-text/final-text.component';
import { CustomerDataComponent } from './print-offer/general/customer-data/customer-data.component';
import { PsdCustomerAddressComponent } from './print-system-documents/psd-customer-address/psd-customer-address.component';
import { PsdEditorAddressComponent } from './print-system-documents/psd-editor-address/psd-editor-address.component';
import { PsdInstallerAddressComponent } from './print-system-documents/psd-installer-address/psd-installer-address.component';
import { PsdOptionsComponent } from './print-system-documents/psd-options/psd-options.component';
import { PsdPublicUtilityDataComponent } from './print-system-documents/psd-public-utility-data/psd-public-utility-data.component';
import { ManageProjectsAbsService } from "./manage-projects-abs.service";
import { DirectAccessGuard } from "../../common/services/direct-access-guard";
import { SharedModule } from "../../shared.module";


const routes: Routes = [
  {
    path: '',
    component: ManageProjectsComponent,
    children: [
      {
        path: 'project',
        component: ProjectComponent, canActivate: [DirectAccessGuard]
      },
      {
        path: 'calculationProfitability',
        component: CalculationProfitabilityComponent, canActivate: [DirectAccessGuard]
      },
      {
        path: 'itemList',
        component: ItemListComponent, canActivate: [DirectAccessGuard]
      },
      {
        path: 'printSystemDocuments',
        component: PrintSystemDocumentsComponent, canActivate: [DirectAccessGuard]
      },
      {
        path: 'printOffer',
        component: PrintOfferComponent, canActivate: [DirectAccessGuard]
      },
      {
        path: 'installationTime',
        component: InstallationTimeComponent, canActivate: [DirectAccessGuard]
      }
    ]
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    SharedModule
  ],
  exports: [
    RouterModule
  ],
  declarations: [
    ManageProjectsComponent,
    ProjectComponent,
    ImportPlanComponent,
    CalculationProfitabilityComponent,
    ItemListComponent,
    InstallationTimeComponent,
    PrintSystemDocumentsComponent,
    PrintOfferComponent,
    WelcomeComponent,
    PaginatorGotoComponent,
    GeneralComponent,
    ExtraServicesComponent,
    OfferTextComponent,
    FinalTextComponent,
    CustomerDataComponent,
    PsdCustomerAddressComponent,
    PsdEditorAddressComponent,
    PsdInstallerAddressComponent,
    PsdOptionsComponent,
    PsdPublicUtilityDataComponent
  ],
  providers: [ManageProjectsAbsService]
})
export class ManageProjectsRoutingModule { }
